import {schema} from 'normalizr';

const options = {
  idAttribute: 'handle',
};

export const Input = new schema.Entity('inputs', {}, options);

export const Question = new schema.Entity(
  'questions',
  {
    inputs: [Input],
    other_inputs: [Input], // eslint-disable-line camelcase
  },
  options
);

export const Step = new schema.Entity(
  'steps',
  {
    questions: [Question],
  },
  options
);
